import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import AdminCreateInvoiceModal from '../AdminCreateInvoiceModal/AdminCreateInvoiceModal';
import AdHocInvoiceModal from '../common/AdHocInvoiceModal/AdHocInvoiceModal';
import './CreateInvoiceDropdown.scss';
function CreateInvoiceDropdown(_ref) {
  var triggerText = _ref.triggerText,
    csrfToken = _ref.csrfToken,
    projectId = _ref.projectId,
    createInvoiceUrl = _ref.createInvoiceUrl,
    companyName = _ref.companyName,
    projectName = _ref.projectName,
    consultantFullName = _ref.consultantFullName,
    adHocInvoicesUrl = _ref.adHocInvoicesUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: "create-invoice-dropdown"
  }, /*#__PURE__*/React.createElement(Dropdown, {
    key: "create-invoice-dropdown",
    id: "create-invoice-dropdown"
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    className: "btn-dropdown-toggle",
    variant: "primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "trigger-text"
  }, triggerText)), /*#__PURE__*/React.createElement(Dropdown.Menu, null, /*#__PURE__*/React.createElement(Dropdown.Item, {
    eventKey: "1"
  }, /*#__PURE__*/React.createElement(AdminCreateInvoiceModal, {
    csrfToken: csrfToken,
    projectId: projectId,
    createInvoiceUrl: createInvoiceUrl,
    triggerText: "Create Timesheet For Consultant",
    triggerType: "button"
  })), /*#__PURE__*/React.createElement(Dropdown.Item, {
    eventKey: "2"
  }, /*#__PURE__*/React.createElement(AdHocInvoiceModal, {
    csrfToken: csrfToken,
    projectId: projectId,
    createInvoiceUrl: createInvoiceUrl,
    triggerText: "Create Ad-Hoc invoice",
    triggerType: "button",
    companyName: companyName,
    projectName: projectName,
    consultantFullName: consultantFullName,
    adHocInvoicesUrl: adHocInvoicesUrl
  })))));
}
CreateInvoiceDropdown.propTypes = {
  createInvoiceUrl: PropTypes.string.isRequired,
  triggerText: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  companyName: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  consultantFullName: PropTypes.string.isRequired,
  adHocInvoicesUrl: PropTypes.string.isRequired
};
CreateInvoiceDropdown.defaultProps = {};
export default CreateInvoiceDropdown;